import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-au-react-components';
import { RichTextRenderer } from '../../RichTextRenderer';

const StyledTitleWithImage = styled.div`
	h4 {
		font-size: ${(props) => (props.titleFontSize || '32') + 'px'};
		line-height: ${(props) => (props.titleLineHeight || '40') + 'px'};
		letter-spacing: 0.25px;
		color: ${(props) => props.titleColor || '#212121'};

		@media (max-width: 575px) {
			font-size: 20px;
			line-height: 28px;
		}
	}

	.heading {
		font-size: ${(props) => (props.headingFontSize || '32') + 'px'};
		line-height: ${(props) => (props.headingLineHeight || '32') + 'px'};
		color: ${(props) => props.headingColor || '#CF004F'};
	}

	.content {
		background-color: ${(props) => props.backgroundColor || 'transparent'};

		&.padding {
			${EmotionBreakpoint('notMobile')} {
				padding: 40px;
			}

			${EmotionBreakpoint('mobile')} {
				padding: 20px;
			}
		}

		${(props) =>
			props.imageAlignment === 'left' &&
			`&:not(.padding) {
			${EmotionBreakpoint('desktop')} {
				padding-left: ${props.gap ? props.gap + 'px' : '60px'} !important;
			}

			${EmotionBreakpoint('tablet')} {
				padding-left: ${props.gap < 61 ? props.gap + 'px' : '60px'} !important;
			}

			${EmotionBreakpoint('mobile')} and (min-width: 576px) {
				padding-left: 20px !important;
			}
		}

			@media (max-width: 575px) {
				margin: ${props.stackInMobile ? '20px 0 0' : '0 0 0 20px'} !important;
			}
    `}
		${(props) =>
			props.imageAlignment === 'right' &&
			`&:not(.padding) {
			${EmotionBreakpoint('desktop')} {
				padding-right: ${props.gap ? props.gap + 'px' : '60px'} !important;
			}

			${EmotionBreakpoint('tablet')} {
				padding-right: ${props.gap < 61 ? props.gap + 'px' : '60px'} !important;
			}

			${EmotionBreakpoint('mobile')} and (min-width: 576px) {
				padding-right: 20px !important;
			}
		}

			@media (max-width: 575px) {
				margin: ${props.stackInMobile ? '0 0 20px' : '0 20px 0 0'} !important;
			}
    `}
	}

	.image {
		@media (max-width: 1170px) and (min-width: 992px) {
			flex-shrink: 0.5 !important;
		}

		@media (min-width: 768px) and (max-width: 991px) {
			flex-shrink: 1 !important;
		}

		@media (min-width: 576px) and (max-width: 767px) {
			flex-shrink: ${(props) =>
				props.stackInMobile ? '1 !important' : '0 !important'};
		}
	}
`;

function TitleWithImage({
	props: {
		heading,
		headingColor,
		headingFontSize,
		headingLineHeight,
		title,
		titleColor,
		titleFontSize,
		titleLineHeight,
		copy,
		copyColor,
		buttonStyle,
		buttonLink,
		buttonCopy,
		imageAlignment,
		gap,
		stackInMobile,
		backgroundColor,
		image,
		imageUrl,
	},
}) {
	return (
		<div className='container'>
			<StyledTitleWithImage
				className={`d-flex justify-content-center align-items-sm-${
					backgroundColor ? 'stretch' : 'center'
				} ${
					imageAlignment === 'right' ? 'flex-sm-row-reverse' : 'flex-sm-row'
				} ${
					stackInMobile
						? imageAlignment === 'right'
							? 'flex-column-reverse align-items-start'
							: 'flex-column align-items-start'
						: 'align-items-center'
				}`}
				stackInMobile={stackInMobile}
				imageAlignment={imageAlignment}
				gap={gap}
				titleColor={titleColor}
				titleFontSize={titleFontSize}
				titleLineHeight={titleLineHeight}
				backgroundColor={backgroundColor}
				headingColor={headingColor}
				headingFontSize={headingFontSize}
				headingLineHeight={headingLineHeight}
			>
				<div className='flex-shrink-0 image'>
					<img
						src={image?.fields?.file?.url || imageUrl}
						alt={title}
						title={title}
						className='mw-100 d-inline-block'
					/>
				</div>
				<div
					className={`content ${
						backgroundColor ? 'padding d-sm-flex align-items-center' : ''
					}`}
				>
					<div>
						{heading && (
							<div className='heading mb-8 font-quentin'>{heading}</div>
						)}
						{title && <h4 className='mb-0 lower'>{title}</h4>}

						{copy?.content && copy?.content.length > 0 && (
							<div className={title ? 'mt-20' : ''}>
								<RichTextRenderer
									content={copy}
									color={copyColor}
									imageTitle={title}
								/>
							</div>
						)}

						{buttonLink && buttonCopy && (
							<div className={title || copy?.content ? 'mt-20' : ''}>
								<a href={buttonLink} className={'btn btn-' + buttonStyle}>
									{buttonCopy}
								</a>
							</div>
						)}
					</div>
				</div>
			</StyledTitleWithImage>
		</div>
	);
}

export default TitleWithImage;
